import * as React from "react";
import { useNavigate } from "react-router-dom";
import {
  BackgroundWrapper,
  ElementsWrapper,
  StyledCloseIcon,
  SummaryWrapper,
} from "src/components/Summary/Summary.components";
import SummaryElement from "src/components/Summary/SummaryElement";
import { useGameContext } from "src/game/useGameContext";
import { CREATE_GAME_PATH } from "src/utils/routesPaths";

const Summary: React.FunctionComponent = () => {
  const { gameState } = useGameContext();
  const navigate = useNavigate();

  const summaryElements = gameState.gameSummary
    ?.filter(task => task.summary)
    .map(task => {
      const { summary, id } = task;
      if (!summary) {
        return null;
      }
      return (
        <SummaryElement key={id} summary={summary} name={task.description} />
      );
    });
  const handleClose = () => {
    navigate(CREATE_GAME_PATH);
  };

  return (
    <BackgroundWrapper>
      <SummaryWrapper>
        <StyledCloseIcon onClick={handleClose} className="closeIcon" />
        <h2>{`Game summary - ${gameState.game?.name}`}</h2>
        <ElementsWrapper isEmpty={summaryElements?.length === 0}>
          {summaryElements?.length !== 0 ? (
            summaryElements
          ) : (
            <h2>There were no votings</h2>
          )}
        </ElementsWrapper>
      </SummaryWrapper>
    </BackgroundWrapper>
  );
};

export default Summary;
